module.exports = __webpack_public_path__ + "static/media/5120.0e078d3c.jpg";